import Vue from 'vue'
const numeral = require('numeral')
// eslint-disable-next-line
const locales = require('numeral/locales')

Vue.filter('formatCurrency', value => {
  return numeral(value).format('$ 0,0[.]00')
})

numeral.locale('pt-br')



// WEBPACK FOOTER //
// ./src/filters/FormatCurrency.js